import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory, useParams, Link } from "react-router-dom";
import swal from "sweetalert";
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination, Thumbs } from 'swiper';
import ShareButtonPopUp from "./PopUp/ShareButtonPopUp";
import UseFullPageLoader from "../FullPageLoader/UseFullPageLoader";
import UseGeoLoaction from "./UseGeoLocation";

SwiperCore.use([Navigation, Pagination, Thumbs]);

const Details = (props) => {
    document.title = "DirtMap - Listing Details";
    const history = useHistory();
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
    const [detail, setDetails] = useState({});
    const userId = localStorage.getItem('user_id');
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [modalShow, setModalShow] = React.useState(false);
    const [loader, showLoader, hideLoader] = UseFullPageLoader();
    const location = UseGeoLoaction();

    const formatTruckLabel = (str) => {
        return str.replace(/_/g, " ")       // replace _ with space
                  .replace(/\b\w/g, c => c.toUpperCase()); // capitalize each word
    }


    useEffect(() => {
        let isMounted = true;
        showLoader();
        axios.get(`api/details/post/site/${id}/${userId}`).then(res => {

            if (isMounted) {
                if (res.data.result) {
                    setDetails(res.data.result);
                    console.log("htthtth" + JSON.stringify(res.data.result));
                    setLoading(false);
                    hideLoader();
                } else if (res.data.status === 'false') {
                    hideLoader();
                    history.push('/');
                    swal("warning", res.data.message, "error");

                }
            }
        });
        return () => {
            isMounted = false;
        };
    }, [id, history]);
    var detail_HTMLDIV = "";

    if (loading) {
        return <div className="fp-container"><img src={"/images/spinner.gif"} className="fp-loader" alt="loading" /></div>;

    } else {
        detail_HTMLDIV =
            detail.images.map((image, index) => {
                //let imgStr = image.substring(image.lastIndexOf("/") + 1);
                let detail_HTMLM = "";

                if (!image) {
                    detail_HTMLM = (
                        <img
                            style={{ listStyle: 'none' }}
                            height="300"
                            width="400"
                            src={"/frontend/images/placeholder.jpg"}
                            className="img-responsive"
                            alt="itemImage"
                        />
                    );
                } else {

                    const fileExt = image.split('.').pop().toLowerCase();

                    if (['jpg','jpeg','png','gif'].includes(fileExt)) {
                        detail_HTMLM = (
                            <img
                                style={{ listStyle: 'none' }}
                                height="300"
                                width="400"
                                src={image}
                                className="img-responsive"
                                alt="itemImage"
                            />
                        );
                    } 
                    else if (['mp4','ogg','mov'].includes(fileExt)) {
                        detail_HTMLM = (
                            <video
                                style={{ listStyle: 'none' }}
                                height="300"
                                width="400"
                                className="img-responsive"
                                controls
                            >
                                <source src={image} type="video/mp4" />
                            </video>
                        );
                    } 
                    else {
                        // fallback if unknown file
                        detail_HTMLM = (
                            <img
                                style={{ listStyle: 'none' }}
                                height="300"
                                width="400"
                                src={"/frontend/images/placeholder.jpg"}
                                className="img-responsive"
                                alt="itemImage"
                            />
                        );
                    }
                }

                return (
                    <SwiperSlide tag="li" key={1 + index}>
                        {detail_HTMLM}
                    </SwiperSlide>

                )
            });
    }

    const updateStatus = (e, id, status) => {
        e.preventDefault();
        let isMounted = true;
        showLoader();
        const thisclicked = e.currentTarget;
        let statusMsg = status === '1' ? 'Renew' : 'Active';
        thisclicked.innerText = statusMsg;
        axios.post(`/api/update/status/post/site/${id}/${status}`).then(res => {
            if (res.data.status_code === 200) {
                swal('success', res.data.message, 'success');
                axios.get(`api/details/post/site/${id}/${userId}`).then(res => {
                    if (isMounted) {
                        if (res.data.result) {
                            setDetails(res.data.result);
                            console.log(res.data.result);
                            setLoading(false);
                            hideLoader();
                        } else if (res.data.status === 'false') {
                            hideLoader();
                            history.push('/');
                            swal("warning", res.data.message, "error");

                        }
                    }
                });
                //thisclicked.closest('tr').remove();
            } else if (res.data.status_code === 404) {
                swal('error', 'No Post Site Id Found', 'error');
                //thisclicked.innerHtml = 'Delete';
            }
        });
    }


    const favorites = (e, id, status) => {
        showLoader();
        e.preventDefault();
        let isMounted = true;
        const userId = localStorage.getItem('user_id');
        const thisclicked = e.currentTarget;
        const data = {
            user_id: userId,
            site_post_id: id,
            status: status
        }
        let el = document.getElementById("__favoriteButtonFontTag");
        el.classList.toggle("fa-heart");
        // const thisclicked = e.currentTarget;
        // let statusMsg = status === '1' ?  `${<i className="fa fa-heart heart-icon-post-listing" aria-hidden="true" />}${'Favorites'}` : `${<i className="fa fa-heart-o heart-icon-post-listing" aria-hidden="true" />}${'Favorites'}`;
        // console.log(statusMsg);
        // thisclicked.innerHTML = statusMsg;
        axios.post(`/api/favorite`, data).then(res => {
            if (res.data.status_code === 200) {
                swal('success', res.data.message, 'success');

                axios.get(`api/details/post/site/${id}/${userId}`).then(res => {
                    if (isMounted) {
                        if (res.data.result) {
                            setDetails(res.data.result);
                            console.log(res.data.result);
                            setLoading(false);
                            hideLoader();
                        } else if (res.data.status === 'false') {
                            hideLoader();
                            history.push('/');
                            swal("warning", res.data.message, "error");

                        }
                    }
                });

            } else if (res.data.status_code === 404) {
                hideLoader();
                swal('error', 'No Post Site Id Found', 'error');
                //thisclicked.innerHtml = 'Delete';
            }
        });
    }


    const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
        var R = 6371; // Radius of the earth in km
        var dLat = deg2rad(lat2 - lat1);  // deg2rad below
        var dLon = deg2rad(lon2 - lon1);
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
            ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d;
    }

    const deg2rad = (deg) => {
        return deg * (Math.PI / 180)
    }


    const secondsToDhms = (seconds) => {
        seconds = Number(seconds);
        var d = Math.floor(seconds / (3600 * 24));
        var h = Math.floor(seconds % (3600 * 24) / 3600);
        var m = Math.floor(seconds % 3600 / 60);
        var s = Math.floor(seconds % 60);

        var dDisplay = d > 0 ? d + (d == 1 ? " day, " : " days, ") : "";
        var hDisplay = h > 0 ? h + (h == 1 ? " hour, " : " hours, ") : "";
        var mDisplay = m > 0 ? m + (m == 1 ? " minute, " : " minutes, ") : "";
        //var sDisplay = s > 0 ? s + (s == 1 ? " second" : " seconds") : "";
        return dDisplay + hDisplay + mDisplay;
    }


    const coordinates = location.loaded ? location.coordinates : '';
    const findDistance = coordinates ? getDistanceFromLatLonInKm(coordinates.lat, coordinates.lng, detail.latitude, detail.longitude) : 0;
    const hour = findDistance ? findDistance / 40 : 0;
    const time = hour * 3600;
    const dayTimeMinutesSecond = secondsToDhms(time);


    return (
        <div>
            <section className="breadcrumb">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 bread-crumb">
                            <Link to="/">Home</Link><span>&gt;</span>
                            <Link to="#">Search</Link>
                            <span>&gt;</span>The Redford Trucks
                        </div>
                    </div>
                </div>
                <hr />
            </section>
            <section className="contentContainer">
                <div className="container">
                    <div className="row">
                        <div className="col-md-6">
                            <h2 className="bottomBorder">{detail.project_name}</h2>
                            <p className="truckInfo bottomBorder">
                                {detail.special_instruction && (
                                    <>
                                        <span>
                                            <i className="fa fa-truck" aria-hidden="true" />
                                            {detail.special_instruction} 
                                        </span>
                                        <span className="space">&nbsp;</span>
                                    </>
                                )}
                               
                                {dayTimeMinutesSecond && (
                                    <>
                                        <span><i className="fa fa-map-marker" aria-hidden="true" /> {dayTimeMinutesSecond
                                            ? dayTimeMinutesSecond : 'Location not Available / Allow yet.'}</span>
                                    </>
                                )}    
                            </p>
                            <p className="mt-4">{detail.description}</p>
                            <div className="aboutTruck lightPinkBg">
                                <table className="table">
                                    <tbody>

                                        {detail.item_type && (
                                            <tr>
                                                <td>Type</td>
                                                <td>{detail.item_type}</td>
                                            </tr>
                                        )}

                                    
                                        {/* Posted & Expires - only for Import, Export, Dump Site */}
                                        {['import', 'export', 'dump_site'].includes(
                                            String(detail.item_type).toLowerCase()
                                        ) && (
                                            <>
                                                <tr>
                                                    <td>Posted</td>
                                                    <td>
                                                        {detail.created_at
                                                            ? new Date(detail.created_at).toLocaleString('en-GB', {
                                                                day: 'numeric',
                                                                month: 'short',
                                                                year: 'numeric',
                                                                hour: 'numeric',
                                                                minute: '2-digit',
                                                                hour12: true
                                                            })
                                                            : '-'}
                                                    </td>
                                                </tr>

                                                <tr>
                                                    <td>Expires</td>
                                                    <td>
                                                        {detail.expiry_date
                                                            ? new Date(detail.expiry_date).toLocaleString('en-GB', {
                                                                day: 'numeric',
                                                                month: 'short',
                                                                year: 'numeric',
                                                                hour: 'numeric',
                                                                minute: '2-digit',
                                                                hour12: true
                                                            })
                                                            : '-'}
                                                    </td>
                                                </tr>
                                            </>
                                        )}


                                        <tr>
                                            <td>Truck Distance From Set Location</td>
                                            <td>
                                                {Math.round(findDistance * 0.62137119)} Miles
                                            </td>
                                        </tr>

                                        {detail.cuyds_of_dirt_min != 0 && (
                                            <tr>
                                                <td>CuYds of Dirt</td>
                                                <td>{detail.cuyds_of_dirt_min}</td>
                                            </tr>
                                        )}

                                    </tbody>
                                </table>
                            </div>

                            {/* {detail.trucks && detail.trucks.length > 0 && (
                                detail.trucks.map((t, index) => (
                                    <p class="truckInfo" key={index}>
                                        <i className="fa fa-truck" aria-hidden="true"></i>
                                        {formatTruckLabel(t.type_of_truck)} - {t.no_of_truck}
                                    </p>
                                ))
                            )} */}

                            {detail.trucks && detail.trucks.length > 0 && (
                            <table className="table table-bordered truckTable">
                                <thead>
                                    <tr>
                                        <th>Type of Truck</th>
                                        <th>No. of Trucks</th>
                                    </tr>
                                </thead>

                                <tbody>
                                        {detail.trucks.map((t, index) => (
                                            <tr key={index}>
                                                <td>{formatTruckLabel(t.type_of_truck)}</td>
                                                <td>{t.no_of_truck}</td>
                                            </tr>
                                        ))}
                                        
                                   
                                </tbody>
                            </table>
                             )}

                            {detail.equipments && detail.equipments.length > 0 && (
                            <table className="table table-bordered truckTable">
                                <thead>
                                    <tr>
                                        <th>Equipment</th>
                                        <th>Quantity</th>
                                    </tr>
                                </thead>

                                <tbody>
                                        {detail.equipments.map((t, index) => (
                                            <tr key={index}>
                                                <td>{formatTruckLabel(t.equipment)}</td>
                                                <td>{t.quantity}</td>
                                            </tr>
                                        ))}
                                        
                                   
                                </tbody>
                            </table>
                            )}

                            <div className="postedByInfo">
                                <h6>Posted By</h6>
                                <div className="postContactInfo">
                                    <div className="userIcon">
                                        <img src={"/frontend/images/u-icon.png"} alt="user icon" />
                                    </div>
                                    <div className="infoAboutUser">
                                        <div><i className="fa fa-map-marker" aria-hidden="true" />{detail.name}</div>
                                        <div><i className="fa fa-phone" aria-hidden="true" />{detail.phone}</div>
                                        <div><i className="fa fa-envelope" aria-hidden="true" /><Link to="#">{detail.email}</Link></div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="order-lg-0 col-md-6 order-md-0 order-first">
                            
                            {/* <Swiper
                                spaceBetween={0}
                                slidesPerView={1}
                                modules={[Thumbs]}
                                thumbs={{ swiper: thumbsSwiper }}
                                navigation={detail?.images?.length > 2}
                                pagination={detail?.images?.length > 2 ? { clickable: true } : false}
                            >
                                {detail?.images
                                    ?.filter(img => img && img.trim() !== "")
                                    .map((img, index) => (
                                        <SwiperSlide key={index}>
                                            <img
                                                src={img}
                                                alt="site"
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                        </SwiperSlide>
                                    ))
                                }
                            </Swiper> */}

                            {(() => {
                            const allMedia = [
                                ...(detail.images || []),
                                ...(detail.videos || [])
                            ];

                            return (
                                <>
                                    <Swiper
                                    spaceBetween={0}
                                    slidesPerView={1}
                                    modules={[Thumbs]}
                                    thumbs={{ swiper: thumbsSwiper }}
                                    navigation={allMedia.length > 1}
                                    pagination={allMedia.length > 1 ? { clickable: true } : false}
                                    >
                                    {allMedia
                                        .filter(file => file && typeof file === "string") // remove invalid values
                                        .map((file, index) => {
                                        const ext = file.split('.').pop().toLowerCase();

                                        // ✅ IMAGE
                                        if (['jpg','jpeg','png','gif'].includes(ext)) {
                                        return (
                                            <SwiperSlide key={index}>
                                            <img
                                                src={file}
                                                alt="site"
                                                style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                            />
                                            </SwiperSlide>
                                        );
                                        }

                                        // ✅ VIDEO
                                        if (['mp4','ogg','mov'].includes(ext)) {
                                        return (
                                            <SwiperSlide key={index}>
                                            <video controls style={{ width: "100%" }}>
                                                <source src={file} type="video/mp4" />
                                            </video>
                                            </SwiperSlide>
                                        );
                                        }

                                        return null;
                                    })}
                                    </Swiper>

                                    {detail.documents && detail.documents.length > 0 && (
                                        <div className="mt-3">
                                            <h6>Documents</h6>

                                            {detail.documents.map((doc, i) => (
                                            <div key={i}>
                                                <a href={doc} target="_blank" rel="noreferrer">
                                                📄 Download Document {i + 1}
                                                </a>
                                            </div>
                                            ))}
                                        </div>
                                        )}
                                </>
                                
                            );
                            })()}

                            {/* <div className="swiper mySwiper">
                                <Swiper
                                    id="thumb"
                                    spaceBetween={7}
                                    slidesPerView={4}
                                    modules={[Thumbs]}
                                    watchSlidesProgress
                                    onSwiper={setThumbsSwiper}
                                >
                                    {detail_HTMLDIV}
                                </Swiper>
                            </div> */}
                            <div className="actionButtons text-right">

                                {/* <a target="_blank" href={detail.document} download="document">
                                    <i className="fa fa-file-text" aria-hidden="true" />
                                    Download
                                </a>

                                <Link to="#" className="button customButton01" onClick={(e) => updateStatus(e, detail.id, detail.status)}>
                                    {detail.status === '1' ? 'Active' : 'Renew'}
                                </Link> */}

                                {/* <Link className="button customButton01" to="#">
                                    <i className="fa fa-share-alt" aria-hidden="true" /> Share
                                </Link> */}

                                {/* <Button variant="primary" onClick={() => setModalShow(true)}>
                                        Launch vertically centered modal
                                    </Button> */}


                                <Link to="#" className="button customButton01" onClick={() => setModalShow(true)}>
                                    <i className="fa fa-share-alt" aria-hidden="true" /> Share
                                </Link>

                                <ShareButtonPopUp
                                    show={modalShow}
                                    onHide={() => setModalShow(false)}
                                />
                                <Link className="button customButton01" id="__favoriteButton" to="#" onClick={(e) => favorites(e, detail.id, detail.is_fav)}>
                                    {detail.is_fav === '1' ? <i className="fa fa-heart heart-icon-post-listing" id="__favoriteButtonFontTag" aria-hidden="true" /> : <i id="__favoriteButtonFontTag" className="fa fa-heart-o heart-icon-post-listing" aria-hidden="true" />}
                                    Favorites
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {loader}
        </div>
    )
}

export default Details;